import { Component, OnInit, inject } from '@angular/core';
import { MandantConfigService } from '@strategies/mandant-config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  private mandantConfigService = inject(MandantConfigService);

  impressumUrl: string;

  dataPrivacyUrl: string;

  hideFooter: boolean | undefined = false;

  constructor() {
    const mandantConfigService = this.mandantConfigService;

    if (mandantConfigService.mandant.hideFooter === true) {
      this.hideFooter = true;
    }
  }

  ngOnInit() {
    this.mandantConfigService.mandantConfig.subscribe(conf => {
      if (conf === null) return;
      this.impressumUrl = conf.impressumUrl;
      this.dataPrivacyUrl = conf.dataPrivacyUrl;
    });
  }
}
